module Meevo.Plugins.Tippy {
    "use strict";

    export class TestConfigurationSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, false, false,
                baseEndpoint, sectionEndpoint, loggingService, dataService,
                noun, identityService, sectionSecurityKey);
        }
    }
}
